var WaitBoardModel = require('../models/profile/wait-board-model');

var AccountSidebarView = require('../../shared/app/views/account/account-sidebar');
var WaitBoardItemView = require('./wait-board/wait-board-item');

var WaitBoardView = Backbone.Epoxy.View.extend({
  template: 'account.waitBoard',
  itemView: WaitBoardItemView,

  events: {
    'click .js-waitboard-action__waitlist': 'onWaitList',
    'click .js-waitlist-action__book': 'onBookAppointment',
  },

  disposeWaitTimesTimeout: false,
  currentWaitTimesTimeout: null,

  initialize: function() {

    this.model = new WaitBoardModel();
    this.collection = this.model.get('waitBoardItems');

    this.acountSidebarView = new AccountSidebarView({
      parent: this
    });
    this.acountSidebarView.activeLink = '.wait-board';

    this.isLoading = true;
    this.dataVersion = 0;
    this.renderVersion = -1;

    this.waitTimer = null;

    var self = this;
    $(window).resize(function() {
      self.fixContentHeight();
    });
  },

  refresh: function() { // called from logout function when available
    if (!bookedby.app.currentClient.get("loggedIn") ) {
      bookedby.app.navigateWithNoAuth('login', {}, 'wait-board', {}, true);
    } else {
      this.setData();
    }
  },

  setData: function() {
    this.disposeWaitTimesTimeout = false;

    if (!bookedby.app.currentClient.get("loggedIn") ) {
      /// commented out by https://salonultimate.atlassian.net/browse/SCWT-49
      /// it was blocking the rendering of Login page when opening this page in incognito
      /// check ticket's video/comments/MR for more info
      // bookedby.app.navigateWithNoAuth('login', {}, 'wait-board', {});
    } else {
      if (!bookedby.staticData.storeGroupSettings.useWaitingList) {
        bookedby.app.navigateWithReplace('start-booking', {});
      } else {
        this.setWaitListData();
      }
    }
  },

  beforeRender: function() {
    if (!bookedby.app.currentClient.get("loggedIn") ) {
      bookedby.app.navigateWithNoAuth('login', {}, 'wait-board', {});
      return false;
    }

    this.setView('#myAccountSidebar', this.acountSidebarView);

    if (this.isLoading) {
      bookedby.app.startLoading();
      this.$el.html('');
      return false;
    }

    return this.model != null;

    /*if (this.renderVersion == this.dataVersion) {
      return false;
    }
    this.renderVersion = this.dataVersion;
    return true;*/
  },

  afterRender: function() {
    if (!this.isLoading) {
      bookedby.app.finishLoading();
    }

    this.applyBindings();

    this.fixContentHeight();
  },

  cleanup: function() {
    console.log("clearing wait board refresh interval");
    if (this.currentWaitTimesTimeout) {
      clearTimeout(this.currentWaitTimesTimeout);
      this.currentWaitTimesTimeout = null;
    }
    this.disposeWaitTimesTimeout = true;

    this.removeBindings();
    this.collection.reset();
    this.model.set(this.model.defaults);
  },

  setWaitTimer: function(model) {
    var isNoResponseFromAPI = _.isNull(model);

    var isFeatureEnabled = model && model.get('isFeatureEnabled');

    // TODO do we need to check on # of queue items before refreshing (or on presence of this guest's appointments in the queue)?
    // TODO confirm that it's ok to just re-draw in case of no API response
    if (isNoResponseFromAPI || isFeatureEnabled) {
      var refreshIntervalSec = bookedby.staticData.storeGroupSettings.useWaitBoardRefreshIntervalSec;
      if (refreshIntervalSec > 0) {
        console.log("setting wait board refresh interval to", refreshIntervalSec, "sec");
        this.currentWaitTimesTimeout = setTimeout(_.bind(this.setWaitListData, this), refreshIntervalSec * 1000);
      }
    }
  },

  fixContentHeight: function () {
    var topBarHeight = $('.top-bar').height();
    var height = $(window).height() - topBarHeight;
    var $elem = $('#myWaitBoard');

    $elem.css('height', height);

    // temporary fix for Chrome's scroll issue where the user is unable to scroll until he resizes the window
    $elem.css('overflow', 'auto');
    _.delay(function() { $elem.css('overflow', ''); }, 300);
  },

  hasChanges: function() {
    return false;
  },

  setWaitListData: function() {
    if (this.disposeWaitTimesTimeout) {
      return;
    }
    this.isLoading = true;

    $.ajax({
      url: bookedby.routes.BOOKING.GET_WAIT_BOARD,
      data: {
        storeGroupUuid: window.bookedby.staticData.storeGroupId,
        today: moment().format('YYYY-MM-DD')
      },
      method: 'GET',
      cache: false,
      dataType: 'json',
      success: _.bind(function(data) {
        this.model.bindModel(data);

        this.isLoading = false;
        this.setWaitTimer(this.model);
        //this.dataVersion += 1;
        //this.render();
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        bookedby.app.logAPIError(textError);
        this.setWaitTimer(null);
      }, this)
    });
  },

  onWaitList: function() {
    bookedby.app.navigateTo('waiting-list');
  },

  onBookAppointment: function() {
    bookedby.app.navigateTo('start-booking');
  },

});

module.exports = WaitBoardView;